import { Box, Chip, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import { theme } from '../theme'
import { getSoftChipSx } from './chipStyles'

interface Props {
  label: string
  value: string
  color: string
  fullWidth?: boolean
  documentPage?: boolean
  compact?: boolean
  borderless?: boolean
  emphasis?: boolean
  maxChipWidth?: string | number
  chipHeight?: number
}

export const DisplayChipLikeTextField: React.FC<Props> = ({
  label,
  value,
  color,
  fullWidth = false,
  documentPage = false,
  compact = false,
  borderless = false,
  emphasis = false,
  maxChipWidth = '100%',
  chipHeight,
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasLabel = Boolean(label)

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={compact && !hasLabel ? 'center' : 'flex-start'}
      height="100%"
      width={fullWidth ? '100%' : 'auto'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          position: 'relative',
          marginTop: compact ? 0 : documentPage ? '1px' : isMobile ? 1 : 2,
          minHeight: compact ? (hasLabel ? 40 : 32) : undefined,
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            position: 'absolute',
            top: '-0.8em',
            left: '0.5em',
            background: 'white',
            paddingLeft: '0.2em',
            paddingRight: '0.2em',
            fontWeight: compact ? 500 : undefined,
            display: hasLabel ? 'block' : 'none',
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{
            border: borderless
              ? 'none'
              : compact
              ? '1px solid rgba(122, 129, 151, 0.18)'
              : '1px solid rgba(0, 0, 0, 0.23)',
            borderRadius: compact ? 8 : '4px',
            padding: borderless ? 0 : compact ? '6px 10px' : '5px',
            display: 'flex',
            alignItems: 'center',
            paddingRight: compact ? '10px' : '15px',
            '&:hover': {
              borderColor: borderless ? undefined : compact ? 'rgba(122, 129, 151, 0.35)' : 'black',
            },
            cursor: 'not-allowed',
            backgroundColor: compact ? 'transparent' : undefined,
          }}
        >
          <Chip
            label={value}
            sx={{
              marginLeft: compact ? 0 : '12px',
              ...getSoftChipSx(color, {
                solid: documentPage,
                height: compact ? chipHeight || (isMobile ? 24 : 26) : 26,
                fontSize: documentPage ? 11.5 : compact ? (isMobile ? 11 : 11.5) : 11.5,
                labelWeight: documentPage ? 500 : 500,
                emphasis,
                maxWidth: maxChipWidth,
              }),
            }}
          />
        </Box>
      </Box>
    </Box>
  )
}
